<div class="p-8 lg:w-[450px] glass-frost-deep border border-white/40 rounded-3xl overflow-hidden shadow-2xl">
  <!-- Header / Icon -->
  <div class="flex justify-center mb-6">
    <div class="w-20 h-20 rounded-2xl bg-red-50 flex items-center justify-center text-red-500 shadow-inner">
      <mat-icon class="!text-4xl !w-10 !h-10 !leading-10">warning</mat-icon>
    </div>
  </div>

  <!-- Content -->
  <div class="text-center mb-10">
    <h3 class="text-2xl font-black text-gray-950 tracking-tight mb-4">Are you sure?</h3>
    <p class="text-gray-500 font-medium leading-relaxed">
      {{ warningMessage | translate | async }}
    </p>
  </div>

  <!-- Actions -->
  <div class="flex items-center gap-4">
    <button mat-flat-button (click)="close()"
      class="flex-1 min-h-[56px] !rounded-2xl border border-gray-100 bg-gray-50 text-gray-500 font-bold hover:bg-gray-100 transition-all uppercase tracking-widest text-[11px]">
      {{ 'story.cancel' | translate | async }}
    </button>
    <button mat-flat-button (click)="approveProcess()"
      class="flex-1 min-h-[56px] !rounded-2xl bg-red-500 text-white font-bold hover:bg-red-600 transition-all shadow-lg shadow-red-500/20 uppercase tracking-widest text-[11px]">
      Confirm Delete
    </button>
  </div>
</div>